import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

const UsersManager = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Estados para o Modal de Formulário
  const [showModal, setShowModal] = useState(false);
  const [userId, setUserId] = useState(null); 
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [saving, setSaving] = useState(false);

  // E-mail do Administrador mestre e e-mail do usuário logado atualmente
  const MASTER_ADMIN_EMAIL = 'admin@jurereblue.com.br';
  const currentUserEmail = (localStorage.getItem('user_email') || '').toLowerCase();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await api.get('/admin/users'); 
      setUsers(response.data);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
      alert('Erro ao carregar a lista de usuários.');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenCreate = () => {
    setUserId(null);
    setName('');
    setEmail('');
    setPassword('');
    setShowModal(true);
  };

  const handleOpenEdit = (user) => {
    setUserId(user.id);
    setName(user.name);
    setEmail(user.email);
    setPassword(''); 
    setShowModal(true);
  };

  const handleSaveUser = async (e) => {
    e.preventDefault();
    if (!name || !email || (!userId && !password)) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    setSaving(true);
    try {
      const payload = { name, email };
      if (password) payload.password = password;

      if (userId) {
        await api.put(`/admin/users/${userId}`, payload);
        
        // Se o usuário editado foi o admin mestre e ele alterou a senha, força o logout
        if (email.toLowerCase() === MASTER_ADMIN_EMAIL && password) {
          alert('Senha do Administrador Master alterada com sucesso! Por segurança, faça login novamente com as novas credenciais.');
          localStorage.removeItem('token');
          localStorage.removeItem('user_name');
          localStorage.removeItem('user_email');
          navigate('/jb-login-acesso-master-control-cms');
          return;
        }

        alert('Usuário updated com sucesso!');
      } else {
        await api.post('/admin/users', payload);
        alert('Usuário cadastrado com sucesso!');
      }

      setShowModal(false);
      fetchUsers(); 
    } catch (error) {
      console.error("Erro ao salvar usuário:", error);
      alert(error.response?.data?.error || 'Erro ao processar requisição.');
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteUser = async (user) => {
    if (user.email.toLowerCase() === MASTER_ADMIN_EMAIL) {
      alert('Ação Proibida! O Administrador mestre não pode ser removido do sistema.');
      return;
    }

    if (window.confirm(`Tem certeza de que deseja remover o usuário "${user.name}" permanentemente?`)) {
      try {
        await api.delete(`/admin/users/${user.id}`);
        alert('Usuário removido com sucesso!');
        fetchUsers();
      } catch (error) {
        console.error("Erro ao excluir usuário:", error);
        alert(error.response?.data?.error || 'Erro ao deletar usuário.');
      }
    }
  };

  return (
    <div className="pb-5">
      <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
        <div>
          <h4 className="fw-bold mb-0">Controle de Usuários</h4>
          <p className="text-muted small mb-0">Adicione, edite ou gerencie as credenciais de acesso ao CMS.</p>
        </div>
        <button className="btn btn-dark btn-sm px-3" onClick={handleOpenCreate}>
          <i className="bi bi-person-plus-fill me-1"></i> Novo Usuário
        </button>
      </div>

      <div className="card shadow-sm border-0">
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0 bg-white">
            <thead className="table-light">
              <tr>
                <th>Nome</th>
                <th>E-mail</th>
                <th>Data de Cadastro</th>
                <th className="text-end">Ações</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="4" className="text-center py-4">Buscando dados no PostgreSQL...</td></tr>
              ) : users.length === 0 ? (
                <tr><td colSpan="4" className="text-center py-4 text-muted">Nenhum usuário cadastrado.</td></tr>
              ) : (
                users.map(user => {
                  const isUserMasterAdmin = user.email.toLowerCase() === MASTER_ADMIN_EMAIL;
                  const amIMasterAdmin = currentUserEmail === MASTER_ADMIN_EMAIL;

                  return (
                    <tr key={user.id}>
                      <td>
                        <div className="fw-bold">{user.name}</div>
                        {isUserMasterAdmin && (
                          <span className="badge bg-secondary p-1 small" style={{ fontSize: '10px' }}>Sistema Master</span>
                        )}
                      </td>
                      <td className="text-muted">{user.email}</td>
                      <td className="small text-muted">
                        {user.created_at ? new Date(user.created_at).toLocaleDateString('pt-BR') : 'N/A'}
                      </td>
                      <td className="text-end">
                        <div className="d-flex gap-2 justify-content-end">
                          
                          {/* Botão de Editar Condicional */}
                          {(!isUserMasterAdmin || amIMasterAdmin) ? (
                            <button className="btn btn-sm btn-outline-secondary" onClick={() => handleOpenEdit(user)} title="Editar usuário">
                              <i className="bi bi-pencil-fill"></i>
                            </button>
                          ) : (
                            <button className="btn btn-sm btn-light border text-muted opacity-50" disabled title="Apenas o próprio administrador mestre pode editar seu cadastro">
                              <i className="bi bi-pencil-fill"></i>
                            </button>
                          )}
                          
                          {/* Botão Excluir Inativo para o Admin Mestre */}
                          {!isUserMasterAdmin ? (
                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteUser(user)} title="Excluir usuário">
                              <i className="bi bi-trash3-fill"></i>
                            </button>
                          ) : (
                            <button className="btn btn-sm btn-light border text-muted opacity-50" disabled title="Administrador mestre não pode ser excluído">
                              <i className="bi bi-trash3-fill"></i>
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-dark text-white">
                <h5 className="modal-title">
                  <i className={`bi ${userId ? 'bi-pencil-square' : 'bi-person-plus-fill'} me-2`}></i>
                  {userId ? 'Editar Usuário' : 'Novo Usuário'}
                </h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
              </div>
              
              <form onSubmit={handleSaveUser}>
                <div className="modal-body p-4">
                  <div className="mb-3">
                    <label className="form-label fw-bold">Nome Completo *</label>
                    <input 
                      type="text" className="form-control" required
                      disabled={email.toLowerCase() === MASTER_ADMIN_EMAIL} 
                      value={name} onChange={(e) => setName(e.target.value)} 
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label fw-bold">E-mail de Acesso *</label>
                    <input 
                      type="email" className="form-control" required
                      disabled={email.toLowerCase() === MASTER_ADMIN_EMAIL} 
                      value={email} onChange={(e) => setEmail(e.target.value)} 
                    />
                  </div>
                  
                  <div className="mb-2">
                    <label className="form-label fw-bold">
                      Senha {userId ? '(Deixe em branco para manter a atual)' : '*'}
                    </label>
                    <input 
                      type="password" className="form-control" 
                      required={!userId} placeholder={userId ? "Digite a nova senha se desejar alterar" : ""}
                      value={password} onChange={(e) => setPassword(e.target.value)} 
                    />
                  </div>
                  {email.toLowerCase() === MASTER_ADMIN_EMAIL && userId && (
                    <div className="text-muted small mt-2 fst-italic">
                      <i className="bi bi-info-circle-fill text-primary me-1"></i>
                      Por ser o administrador mestre, apenas a senha pode ser redefinida nesta tela.
                    </div>
                  )}
                </div>
                
                <div className="modal-footer bg-light">
                  <button type="button" className="btn btn-outline-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
                  <button type="submit" className="btn btn-dark px-4" disabled={saving}>
                    {saving ? 'Gravando...' : <><i className="bi bi-check-circle-fill me-1"></i> Salvar</>}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsersManager;